import { fetchData } from 'api/services/mediaPlanning/utils';
import { ApiResponse } from 'api/services/mediaPlanning/types';
import { CAMPAIGN } from './mediaPlanning';
import { CountryFormState } from '../../../store/planStore';

export interface Prediction {
  predictionId?: string;
  budget?: number;
  currency?: string;
  reach?: number;
  impressions?: number;
  clicks?: number;
  videoViews?: number;
  segmentShare?: number;
}

export interface MetaPredictionsResponse {
  country?: string;
  campaignId?: string;
  existingPrediction?: Prediction;
  newPrediction?: Prediction;
  message?: string;
  status?: string;
}

export interface MetaPredictionsData {
  status: string;
  value?: MetaPredictionsResponse;
}

export interface MetaPredictions {
  status: string;
  data: MetaPredictionsData[];
}
export const getMetaPredictionsValidity = async (mediaPlanId: string) => {
  return fetchData<MetaPredictions>(
    `/${CAMPAIGN}/check-meta-predictions-validity?mediaPlanId=${mediaPlanId}`
  );
};
